export enum ConditionOperator {
  CONTAINS = 'contains',
  NOT_CONTAINS = 'not_contains',
  EQUALS = 'equals',
  NOT_EQUALS = 'not_equals',
  STARTS_WITH = 'starts_with',
  ENDS_WITH = 'ends_with',
  IS_EMPTY = 'is_empty',
  IS_NOT_EMPTY = 'is_not_empty',
  IS_TRUE = 'is_true',
  IS_FALSE = 'is_false',
}

export const EmailVariable = {
  SUBJECT: 'starter.email.subject',
  BODY: 'starter.email.body',
  DATE_TIME: 'starter.email.dateTime',
  TO: 'starter.email.to',
  CC: 'starter.email.cc',
  SENDER_NAME: 'starter.email.senderName',
  SENDER_EMAIL: 'starter.email.senderEmail',
  ATTACHMENTS: 'starter.email.attachments',
  MESSAGE_ID: 'starter.email.messageId',
  RECIPIENTS: 'starter.email.recipients',
} as const;

export const EmailVariableLabelMap: Record<string, string> = {
  [EmailVariable.SUBJECT]: 'flowEditor.variables.emailSubject',
  [EmailVariable.BODY]: 'flowEditor.variables.emailBody',
  [EmailVariable.DATE_TIME]: 'flowEditor.variables.emailDateTime',
  [EmailVariable.TO]: 'flowEditor.variables.emailTo',
  [EmailVariable.CC]: 'flowEditor.variables.emailCc',
  [EmailVariable.SENDER_NAME]: 'flowEditor.variables.senderDisplayName',
  [EmailVariable.SENDER_EMAIL]: 'flowEditor.variables.senderEmail',
  [EmailVariable.ATTACHMENTS]: 'flowEditor.variables.emailAttachments',
  [EmailVariable.MESSAGE_ID]: 'flowEditor.variables.emailMessageId',
  [EmailVariable.RECIPIENTS]: 'flowEditor.variables.emailRecipients',
};

export const StarterSlackVariable = {
  MESSAGE: 'starter.slack.message',
  CHANNEL: 'starter.slack.channel',
  CHANNEL_ID: 'starter.slack.channelId',
  WORKSPACE_ID: 'starter.slack.workspaceId',
  AUTHOR: 'starter.slack.author',
  AUTHOR_ID: 'starter.slack.authorId',
  DATE_TIME: 'starter.slack.dateTime',
  ATTACHMENTS: 'starter.slack.attachments',
} as const;

export const EmailVariablePlain = {
  SUBJECT: 'email.subject',
  BODY: 'email.body',
  SENDER_NAME: 'email.senderName',
  SENDER_EMAIL: 'email.senderEmail',
  TO: 'email.to',
  CC: 'email.cc',
  DATE_TIME: 'email.dateTime',
  RECIPIENTS: 'email.recipients',
  MESSAGE_ID: 'email.messageId',
} as const;

export const SlackVariablePlain = {
  MESSAGE: 'slack.message',
  CHANNEL: 'slack.channel',
  CHANNEL_ID: 'slack.channelId',
  WORKSPACE_ID: 'slack.workspaceId',
  AUTHOR: 'slack.author',
  AUTHOR_ID: 'slack.authorId',
  DATE_TIME: 'slack.dateTime',
} as const;

export const InstagramVariablePlain = {
  MESSAGE: 'instagram.message',
  SENDER_NAME: 'instagram.senderName',
  AUTHOR_ID: 'instagram.authorId',
  CONVERSATION_ID: 'instagram.conversationId',
  ACCOUNT_ID: 'instagram.accountId',
  ACCOUNT_USERNAME: 'instagram.accountUsername',
  DATE_TIME: 'instagram.dateTime',
} as const;

export const StarterInstagramVariable = {
  MESSAGE: 'starter.instagram.message',
  SENDER_NAME: 'starter.instagram.senderName',
  AUTHOR_ID: 'starter.instagram.authorId',
  CONVERSATION_ID: 'starter.instagram.conversationId',
  ACCOUNT_ID: 'starter.instagram.accountId',
  ACCOUNT_USERNAME: 'starter.instagram.accountUsername',
  DATE_TIME: 'starter.instagram.dateTime',
} as const;

export const WhatsAppVariablePlain = {
  MESSAGE: 'whatsapp.message',
  SENDER_NAME: 'whatsapp.senderName',
  SENDER_USERNAME: 'whatsapp.senderUsername',
  COUNTERPART_ID: 'whatsapp.counterpartId',
  PHONE_NUMBER_ID: 'whatsapp.phoneNumberId',
  DISPLAY_PHONE_NUMBER: 'whatsapp.displayPhoneNumber',
  DATE_TIME: 'whatsapp.dateTime',
} as const;

export const StarterWhatsAppVariable = {
  MESSAGE: 'starter.whatsapp.message',
  SENDER_NAME: 'starter.whatsapp.senderName',
  SENDER_USERNAME: 'starter.whatsapp.senderUsername',
  COUNTERPART_ID: 'starter.whatsapp.counterpartId',
  PHONE_NUMBER_ID: 'starter.whatsapp.phoneNumberId',
  DISPLAY_PHONE_NUMBER: 'starter.whatsapp.displayPhoneNumber',
  DATE_TIME: 'starter.whatsapp.dateTime',
} as const;

export const GitHubVariablePlain = {
  EVENT: 'github.event',
  ACTION: 'github.action',
  REPOSITORY: 'github.repository',
  URL: 'github.url',
  AUTHOR: 'github.author',
  BODY: 'github.body',
  REF: 'github.ref',
} as const;

export const StarterGitHubVariable = {
  EVENT: 'starter.github.event',
  ACTION: 'starter.github.action',
  REPOSITORY: 'starter.github.repository',
  URL: 'starter.github.url',
  AUTHOR: 'starter.github.author',
  BODY: 'starter.github.body',
  REF: 'starter.github.ref',
} as const;

export const StarterGbpVariable = {
  REVIEW_NAME: 'starter.gbp.reviewName',
  REVIEW_ID: 'starter.gbp.reviewId',
  RATING: 'starter.gbp.rating',
  AUTHOR_NAME: 'starter.gbp.authorName',
  REVIEW_TEXT: 'starter.gbp.reviewText',
  LOCATION_NAME: 'starter.gbp.locationName',
  IS_UPDATE: 'starter.gbp.isUpdate',
  EXISTING_REPLY: 'starter.gbp.existingReply',
  CREATED_AT: 'starter.gbp.createdAt',
} as const;

export const StarterGbpVariableLabelMap: Record<string, string> = {
  [StarterGbpVariable.REVIEW_NAME]: 'flowEditor.variables.gbpReviewName',
  [StarterGbpVariable.REVIEW_ID]: 'flowEditor.variables.gbpReviewId',
  [StarterGbpVariable.RATING]: 'flowEditor.variables.gbpRating',
  [StarterGbpVariable.AUTHOR_NAME]: 'flowEditor.variables.gbpAuthorName',
  [StarterGbpVariable.REVIEW_TEXT]: 'flowEditor.variables.gbpReviewText',
  [StarterGbpVariable.LOCATION_NAME]: 'flowEditor.variables.gbpLocationName',
  [StarterGbpVariable.IS_UPDATE]: 'flowEditor.variables.gbpIsUpdate',
  [StarterGbpVariable.EXISTING_REPLY]: 'flowEditor.variables.gbpExistingReply',
  [StarterGbpVariable.CREATED_AT]: 'flowEditor.variables.gbpCreatedAt',
};

export const FacebookVariablePlain = {
  COMMENT_ID: 'facebook.commentId',
  COMMENT_TEXT: 'facebook.commentText',
  POST_ID: 'facebook.postId',
  PAGE_ID: 'facebook.pageId',
  PAGE_NAME: 'facebook.pageName',
  AUTHOR_NAME: 'facebook.authorName',
  AUTHOR_ID: 'facebook.authorId',
  PARENT_COMMENT_ID: 'facebook.parentCommentId',
  DATE_TIME: 'facebook.dateTime',
} as const;

export const StarterFacebookVariable = {
  COMMENT_ID: 'starter.facebook.commentId',
  COMMENT_TEXT: 'starter.facebook.commentText',
  POST_ID: 'starter.facebook.postId',
  PAGE_ID: 'starter.facebook.pageId',
  PAGE_NAME: 'starter.facebook.pageName',
  AUTHOR_NAME: 'starter.facebook.authorName',
  AUTHOR_ID: 'starter.facebook.authorId',
  PARENT_COMMENT_ID: 'starter.facebook.parentCommentId',
  DATE_TIME: 'starter.facebook.dateTime',
} as const;

export const FacebookMessengerVariablePlain = {
  MESSAGE: 'facebookMessenger.message',
  SENDER_NAME: 'facebookMessenger.senderName',
  AUTHOR_ID: 'facebookMessenger.authorId',
  CONVERSATION_ID: 'facebookMessenger.conversationId',
  PAGE_ID: 'facebookMessenger.pageId',
  PAGE_NAME: 'facebookMessenger.pageName',
  DATE_TIME: 'facebookMessenger.dateTime',
} as const;

export const StarterFacebookMessengerVariable = {
  MESSAGE: 'starter.facebookMessenger.message',
  SENDER_NAME: 'starter.facebookMessenger.senderName',
  AUTHOR_ID: 'starter.facebookMessenger.authorId',
  CONVERSATION_ID: 'starter.facebookMessenger.conversationId',
  PAGE_ID: 'starter.facebookMessenger.pageId',
  PAGE_NAME: 'starter.facebookMessenger.pageName',
  DATE_TIME: 'starter.facebookMessenger.dateTime',
} as const;

export const DoBoxVariablePlain = {
  INBOX_ENTRY_ID: 'dobox.inboxEntryId',
  SUBJECT: 'dobox.subject',
  DESCRIPTION: 'dobox.description',
  TASK_GROUP_NAME: 'dobox.taskGroupName',
  TASK_LABEL_NAMES: 'dobox.taskLabelNames',
  DUE_AT: 'dobox.dueAt',
  ADDED_PARTICIPANT_NAMES: 'dobox.addedParticipantNames',
  ADDED_LABEL_NAMES: 'dobox.addedLabelNames',
  REMOVED_LABEL_NAMES: 'dobox.removedLabelNames',
  NEW_TASK_GROUP_NAME: 'dobox.newTaskGroupName',
  COMMENT_ID: 'dobox.commentId',
  COMMENT_MESSAGE: 'dobox.commentMessage',
  COMMENT_AUTHOR: 'dobox.commentAuthor',
} as const;

export const DebounceVariable = {
  CHANNEL_ID: 'debounce.channelId',
  WORKSPACE_ID: 'debounce.workspaceId',
  SPACE_NAME: 'debounce.spaceName',
  EMAIL_ADDRESS: 'debounce.emailAddress',
} as const;

export const DoBoxVariable = {
  INBOX_ENTRY_ID: 'starter.dobox.inboxEntryId',
  // Populated from getDetailedInboxEntry (DOBOX_CREATED, COMMENT_ADDED)
  SUBJECT: 'starter.dobox.subject',
  DESCRIPTION: 'starter.dobox.description',
  TASK_GROUP_NAME: 'starter.dobox.taskGroupName',
  TASK_LABEL_NAMES: 'starter.dobox.taskLabelNames',
  DUE_AT: 'starter.dobox.dueAt',
  // MODIFY-based deltas
  ADDED_PARTICIPANT_NAMES: 'starter.dobox.addedParticipantNames',
  ADDED_LABEL_NAMES: 'starter.dobox.addedLabelNames',
  REMOVED_LABEL_NAMES: 'starter.dobox.removedLabelNames',
  NEW_TASK_GROUP_NAME: 'starter.dobox.newTaskGroupName',
  // Comment
  COMMENT_ID: 'starter.dobox.commentId',
  COMMENT_MESSAGE: 'starter.dobox.commentMessage',
  COMMENT_AUTHOR: 'starter.dobox.commentAuthor',
} as const;

export const DoBoxVariableLabelMap: Record<string, string> = {
  [DoBoxVariable.INBOX_ENTRY_ID]: 'flowEditor.variables.doboxInboxEntryId',
  [DoBoxVariable.SUBJECT]: 'flowEditor.variables.doboxSubject',
  [DoBoxVariable.DESCRIPTION]: 'flowEditor.variables.doboxDescription',
  [DoBoxVariable.TASK_GROUP_NAME]: 'flowEditor.variables.doboxTaskGroupName',
  [DoBoxVariable.TASK_LABEL_NAMES]: 'flowEditor.variables.doboxTaskLabelNames',
  [DoBoxVariable.DUE_AT]: 'flowEditor.variables.doboxDueAt',
  [DoBoxVariable.ADDED_PARTICIPANT_NAMES]:
    'flowEditor.variables.doboxAddedParticipantNames',
  [DoBoxVariable.ADDED_LABEL_NAMES]:
    'flowEditor.variables.doboxAddedLabelNames',
  [DoBoxVariable.REMOVED_LABEL_NAMES]:
    'flowEditor.variables.doboxRemovedLabelNames',
  [DoBoxVariable.NEW_TASK_GROUP_NAME]:
    'flowEditor.variables.doboxNewTaskGroupName',
  [DoBoxVariable.COMMENT_ID]: 'flowEditor.variables.doboxCommentId',
  [DoBoxVariable.COMMENT_MESSAGE]: 'flowEditor.variables.doboxCommentMessage',
  [DoBoxVariable.COMMENT_AUTHOR]: 'flowEditor.variables.doboxCommentAuthor',
};

export const SlackVariableLabelMap: Record<string, string> = {
  [StarterSlackVariable.MESSAGE]: 'flowEditor.variables.slackMessage',
  [StarterSlackVariable.CHANNEL]: 'flowEditor.variables.slackChannel',
  [StarterSlackVariable.CHANNEL_ID]: 'flowEditor.variables.slackChannelId',
  [StarterSlackVariable.WORKSPACE_ID]: 'flowEditor.variables.slackWorkspaceId',
  [StarterSlackVariable.AUTHOR]: 'flowEditor.variables.slackAuthor',
  [StarterSlackVariable.AUTHOR_ID]: 'flowEditor.variables.slackAuthorId',
  [StarterSlackVariable.DATE_TIME]: 'flowEditor.variables.slackDateTime',
  [StarterSlackVariable.ATTACHMENTS]: 'flowEditor.variables.slackAttachments',
};

export const StarterGoogleChatVariable = {
  MESSAGE: 'starter.googleChat.message',
  SPACE_NAME: 'starter.googleChat.spaceName',
  SPACE_ID: 'starter.googleChat.spaceId',
  SPACE_TYPE: 'starter.googleChat.spaceType',
  EMAIL_ADDRESS: 'starter.googleChat.emailAddress',
  AUTHOR: 'starter.googleChat.author',
  AUTHOR_ID: 'starter.googleChat.authorId',
  AUTHOR_EMAIL: 'starter.googleChat.authorEmail',
  THREAD_NAME: 'starter.googleChat.threadName',
  DATE_TIME: 'starter.googleChat.dateTime',
} as const;

export const GoogleChatVariablePlain = {
  MESSAGE: 'googleChat.message',
  SPACE_NAME: 'googleChat.spaceName',
  SPACE_ID: 'googleChat.spaceId',
  SPACE_TYPE: 'googleChat.spaceType',
  EMAIL_ADDRESS: 'googleChat.emailAddress',
  AUTHOR: 'googleChat.author',
  AUTHOR_ID: 'googleChat.authorId',
  AUTHOR_EMAIL: 'googleChat.authorEmail',
  THREAD_NAME: 'googleChat.threadName',
  DATE_TIME: 'googleChat.dateTime',
} as const;

export const GoogleChatVariableLabelMap: Record<string, string> = {
  [StarterGoogleChatVariable.MESSAGE]: 'flowEditor.variables.googleChatMessage',
  [StarterGoogleChatVariable.SPACE_NAME]:
    'flowEditor.variables.googleChatSpaceName',
  [StarterGoogleChatVariable.SPACE_ID]:
    'flowEditor.variables.googleChatSpaceId',
  [StarterGoogleChatVariable.SPACE_TYPE]:
    'flowEditor.variables.googleChatSpaceType',
  [StarterGoogleChatVariable.EMAIL_ADDRESS]:
    'flowEditor.variables.googleChatEmailAddress',
  [StarterGoogleChatVariable.AUTHOR]: 'flowEditor.variables.googleChatAuthor',
  [StarterGoogleChatVariable.AUTHOR_ID]:
    'flowEditor.variables.googleChatAuthorId',
  [StarterGoogleChatVariable.AUTHOR_EMAIL]:
    'flowEditor.variables.googleChatAuthorEmail',
  [StarterGoogleChatVariable.THREAD_NAME]:
    'flowEditor.variables.googleChatThreadName',
  [StarterGoogleChatVariable.DATE_TIME]:
    'flowEditor.variables.googleChatDateTime',
};

export enum FlowTemplateId {
  SMART_REPLIES = 'SMART_REPLIES',
  DAILY_UNREAD_SUMMARY = 'DAILY_UNREAD_SUMMARY',
  VIP_EMAIL_ALERTS = 'VIP_EMAIL_ALERTS',
  AUTO_LABEL_ACTION_ITEMS = 'AUTO_LABEL_ACTION_ITEMS',
  DRAFT_REPLY = 'DRAFT_REPLY',
  MEETING_ACTION_ITEMS = 'MEETING_ACTION_ITEMS',
  FOLLOW_UP_TRACKER = 'FOLLOW_UP_TRACKER',
  CHANNEL_DIGEST = 'CHANNEL_DIGEST',
  MORNING_BRIEFING = 'MORNING_BRIEFING',
  END_OF_DAY_REPORT = 'END_OF_DAY_REPORT',
}

export const CalendarVariable = {
  EVENT_ID: 'calendar.eventId',
  SUMMARY: 'calendar.summary',
  RESPONSE_STATUS: 'calendar.responseStatus',
  ORGANIZER: 'calendar.organizer',
  ORGANIZER_NAME: 'calendar.organizerName',
  START_TIME: 'calendar.startTime',
  END_TIME: 'calendar.endTime',
  TIME_ZONE: 'calendar.timeZone',
} as const;

/**
 * Starter-namespaced aliases for calendar variables. Dual-seeded alongside the
 * bare `calendar.*` keys so a `{{starter.calendar.*}}` reference (the form the
 * editor's variable picker emits) resolves, matching every other trigger family.
 */
export const StarterCalendarVariable = {
  EVENT_ID: 'starter.calendar.eventId',
  SUMMARY: 'starter.calendar.summary',
  RESPONSE_STATUS: 'starter.calendar.responseStatus',
  ORGANIZER: 'starter.calendar.organizer',
  ORGANIZER_NAME: 'starter.calendar.organizerName',
  START_TIME: 'starter.calendar.startTime',
  END_TIME: 'starter.calendar.endTime',
  TIME_ZONE: 'starter.calendar.timeZone',
} as const;

/**
 * Starter context variables for SCHEDULE-triggered flows.
 * Populated by `scheduledResolution` at fire time.
 *
 * Note: `cronExpression` and `timezone` are on the agent trigger record, not
 * the queue body, so they are not populated here (future work: pass deps into
 * the resolution and fetch the trigger).
 */
export const StarterScheduleVariable = {
  /** ISO timestamp of the scheduled fire, e.g. "2026-05-21T09:00:00.000Z" */
  FIRED_AT: 'starter.schedule.firedAt',
  /** Human-readable local date in user's system timezone, e.g. "2026-05-21" */
  FIRE_DATE_LOCAL: 'starter.schedule.fireDateLocal',
  /** Human-readable local time in user's system timezone, e.g. "09:00" */
  FIRE_TIME_LOCAL: 'starter.schedule.fireTimeLocal',
} as const;

/**
 * Starter context variables for MANUAL-triggered flows.
 * Populated by `manualResolution` when a user manually runs a flow.
 *
 * Note: `source` (e.g. "manual_button" vs "run_flow_now_tool") is not
 * present in the queue body and is not populated here (future work: add
 * a `source` field to `ManualQueueBody`).
 */
export const StarterManualVariable = {
  /** ISO timestamp of when the manual trigger fired */
  TRIGGERED_AT: 'starter.manual.triggeredAt',
  /** userId of the user who triggered the flow (always the flow owner in MVP) */
  TRIGGERED_BY_USER_ID: 'starter.manual.triggeredByUserId',
} as const;

/**
 * Starter context variables for KNOWLEDGE-triggered flows (KNOWLEDGE_PAGE_CREATED).
 * Populated by `knowledgePageEventResolution` at fire time.
 *
 * Namespace follows the existing `starter.<platform>.<field>` convention.
 * Note: spec and design docs reference `{{trigger.*}}` — in this codebase the
 * canonical namespace is `starter.knowledge.*`. The spec notation is informal;
 * downstream step configs must use `{{starter.knowledge.pageContent}}` etc.
 */
export const StarterKnowledgeVariable = {
  PAGE_ID: 'starter.knowledge.pageId',
  SPACE_ID: 'starter.knowledge.spaceId',
  PAGE_TITLE: 'starter.knowledge.pageTitle',
  PAGE_PATH: 'starter.knowledge.pagePath',
  PAGE_CONTENT: 'starter.knowledge.pageContent',
  PAGE_VERSION: 'starter.knowledge.pageVersion',
  PARENT_PAGE_ID: 'starter.knowledge.parentPageId',
  OWNER_TYPE: 'starter.knowledge.ownerType',
  OWNER_ID: 'starter.knowledge.ownerId',
} as const;

// Plain 'person.*' namespace by design — matches the DoBoxVariablePlain precedent, not starter.<platform>.*; generateAgentValidator's allowlist references these values verbatim.
export const StarterPeopleVariable = {
  ID: 'person.id',
  DISPLAY_NAME: 'person.displayName',
  EMAILS: 'person.emails',
  PHONES: 'person.phones',
  JOB_TITLE: 'person.jobTitle',
  NOTES: 'person.notes',
  ORIGIN: 'person.origin',
  TEAM_ID: 'person.teamId',
} as const;

export const StarterBrainSignalVariable = {
  NAME: 'starter.signal.name',
  DEFINITION_ID: 'starter.signal.definitionId',
  TEMPLATE_ID: 'starter.signal.templateId',
  TRIGGER_KEY: 'starter.signal.triggerKey',
  LEVEL: 'starter.signal.level',
  PREVIOUS_LEVEL: 'starter.signal.previousLevel',
  STATUS: 'starter.signal.status',
  ENTITY_ID: 'starter.signal.entity.id',
  ENTITY_TYPE: 'starter.signal.entity.type',
  ENTITY_NAME: 'starter.signal.entity.name',
  SUMMARY: 'starter.signal.summary',
  REASON_CODES: 'starter.signal.reasonCodes',
  EVIDENCE: 'starter.signal.evidence',
  OPENED_AT: 'starter.signal.openedAt',
  LAST_CHANGE_AT: 'starter.signal.lastChangeAt',
  LINK: 'starter.signal.link',
  TEAM_ID: 'starter.signal.teamId',
} as const;

export const StarterTeamsVariable = {
  MESSAGE: 'starter.teams.message',
  CHAT_ID: 'starter.teams.chatId',
  CHAT_NAME: 'starter.teams.chatName',
  CHAT_TYPE: 'starter.teams.chatType',
  AUTHOR_NAME: 'starter.teams.authorName',
  AUTHOR_EMAIL: 'starter.teams.authorEmail',
  MESSAGE_URL: 'starter.teams.messageUrl',
  TENANT_ID: 'starter.teams.tenantId',
  HOME_ACCOUNT_ID: 'starter.teams.homeAccountId',
  MESSAGE_ID: 'starter.teams.messageId',
  RECEIVED_AT: 'starter.teams.receivedAt',
} as const;

export const TeamsVariablePlain = {
  MESSAGE: 'teams.message',
  CHAT_ID: 'teams.chatId',
  CHAT_NAME: 'teams.chatName',
  CHAT_TYPE: 'teams.chatType',
  AUTHOR_NAME: 'teams.authorName',
  AUTHOR_EMAIL: 'teams.authorEmail',
  MESSAGE_URL: 'teams.messageUrl',
  TENANT_ID: 'teams.tenantId',
  HOME_ACCOUNT_ID: 'teams.homeAccountId',
  MESSAGE_ID: 'teams.messageId',
  RECEIVED_AT: 'teams.receivedAt',
} as const;
